/**
 * PracticeRecord - what is returned from the api as part of the add practice record response.
 */
export default class PracticeRecord {
  id: number;
  date: string;
  detail: string;
  lessonId: number;
  segmentId: number;
  userId: number;
  duration: number;
  mode: string;
  tempo: number;
  hands: string;
  scorePercentage: number;
  noteScore: number;
  bonusScore: number;
  totalScore: number;
  starScore: number;
  missedNotes: number;
  wrongNotes: number;
  totalNotes: number;
  rhythmAccNotes: number;
  rhythmInAccNotes: number;
  progress: number; //indicates whether arrow is up or down. legacy offline: view.chart.progressArrow = correctNotes > 60 ? 1 : -1;    legacy: view.chart.progressArrow = record.progress;  see PlaygroundApp AccuracyChart and LessonResultsMediator
  isSectionComplete: boolean;
  isFirstTimeSectionComplete: boolean;
  hasUnlockedSongs: boolean;
  sectionId?: number;

  constructor({ id, date, detail, lessonId, segmentId, userId, duration, mode, tempo, hands, scorePercentage, noteScore, bonusScore, totalScore, starScore, missedNotes, wrongNotes, totalNotes, rhythmAccNotes, rhythmInAccNotes, progress, isSectionComplete, isFirstTimeSectionComplete, hasUnlockedSongs, sectionId }: PracticeRecord) {
    Object.assign(this, { id, date, detail, lessonId, segmentId, userId, duration, mode, tempo, hands, scorePercentage, noteScore, bonusScore, totalScore, starScore, missedNotes, wrongNotes, totalNotes, rhythmAccNotes, rhythmInAccNotes, progress, isSectionComplete, isFirstTimeSectionComplete, hasUnlockedSongs, sectionId });
  }
}
